import React, { useContext } from "react";
import ThemeContext from "../lib/theme-context";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarHalfIcon from "@mui/icons-material/StarHalf";

const StarRating = ({ rating, onRatingChange, label, description, disabled = false }) => {
  const theme = useContext(ThemeContext);

  const handleStarClick = (value, isHalf = false) => {
    if (!disabled) {
      const finalValue = isHalf ? value - 0.5 : value;
      onRatingChange(finalValue);
    }
  };

  const getStarIcon = (starValue) => {
    if (rating >= starValue) {
      return (
        <StarIcon
          style={{
            fontSize: "28px",
            color: "#ED9E0E",
            filter: "drop-shadow(0 2px 4px rgba(237, 158, 14, 0.3))",
          }}
        />
      );
    } else if (rating >= starValue - 0.5) {
      return (
        <StarHalfIcon
          style={{
            fontSize: "28px",
            color: "#ED9E0E",
            filter: "drop-shadow(0 2px 4px rgba(237, 158, 14, 0.3))",
          }}
        />
      );
    } else {
      return (
        <StarBorderIcon
          style={{
            fontSize: "28px",
            color: theme[0] === "dark" ? "#4b5563" : "#d1d5db",
          }}
        />
      );
    }
  };

  return (
    <div
      style={{
        padding: "14px 18px",
      }}
    >
      <div style={{ marginBottom: "10px", textAlign: "center" }}>
        <p
          style={{
            fontSize: "13px",
            fontWeight: "700",
            letterSpacing: "0.3px",
            color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
            margin: "0 0 6px 0",
          }}
        >
          {label}
        </p>
        <p
          style={{
            fontSize: "12px",
            fontWeight: "400",
            color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
            margin: 0,
            lineHeight: "1.4",
          }}
        >
          {description}
        </p>
      </div>

      <div
        style={{
          display: "flex",
          gap: "6px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {[1, 2, 3, 4, 5].map((star) => (
          <div
            key={star}
            style={{
              cursor: disabled ? "default" : "pointer",
              transition: "all 0.2s ease",
              transform: rating >= star ? "scale(1.05)" : "scale(1)",
              position: "relative",
            }}
            onMouseEnter={(e) => {
              if (!disabled) {
                e.currentTarget.style.transform = "scale(1.15)";
              }
            }}
            onMouseLeave={(e) => {
              if (!disabled) {
                e.currentTarget.style.transform =
                  rating >= star ? "scale(1.05)" : "scale(1)";
              }
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const clickX = e.clientX - rect.left;
                const isHalf = clickX < rect.width / 2;
                handleStarClick(star, isHalf);
              }}
            >
              {getStarIcon(star)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StarRating;
